exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-nav-container{width:var(--nav-container-width)}", ""]);

// exports
